import { render, staticRenderFns } from "./CartRightBar.vue?vue&type=template&id=ecb74d9e"
import script from "./CartRightBar.vue?vue&type=script&lang=js"
export * from "./CartRightBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports